module.exports = __webpack_public_path__ + "static/media/instructivova3.31126bae.png";